import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dallas/$slug")({
  component: () => <Outlet />,
});
